/* any functionality that external components need, and thus must be exported, goes in this file */
export var findOptionByValue = function findOptionByValue(value, options, onFindOption) {
  var foundIndex = options.findIndex(function (option) {
    var optionValue = typeof option === 'string' ? option : option.value;
    return optionValue === value;
  });

  if (~foundIndex) {
    onFindOption(foundIndex);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/listbox/dist/esm/externals.js
// module id = 4508
// module chunks = 11